export const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
}
export const isProductUnavailable = (productsByBrand, item) => {
  const pendingStock = item.product_variants.allowed_inventory_quantity;
  const inventoryTracked = item.product_variants.inventory_management;

  if (item?.product_variants?.inventory_status !== "IN_STOCK") return true;

  if (item?.products?.store_products?.length === 0) return true;
  if (item?.products?.user.invitees?.[0]?.invite_status === 'accepted' ||
    item?.products?.user.inviters?.[0]?.invite_status === 'accepted') {
    return false;
  }

  // if (!item?.products?.user.invitees?.length && !item?.products?.user.inviters?.length) {
  //   return true;
  // }
  if (productsByBrand?.brand_user?.access_token?.is_active !== true) return true;

  if (item?.products?.product_status?.status !== 'active') return true;

  if (item?.product_variants?.status !== '1') return true;


  if (!inventoryTracked) return false;

  if (pendingStock === 0) return true;

  if (item.product_variants.status !== '1') return true;
  if (!item.products || item.products.status !== 1) return true;
  if (!productsByBrand?.brand_user?.access_token?.is_active) return true;
  if (item?.product_variants?.is_deleted) return true;

  return false;
};
export const checkCheckoutEnabled = (cartItems) => {
    let checkDisabled = false;
    cartItems?.map((cart, i) => {
      cart.cart_items.map((item, i) => {
        if (isProductUnavailable(cart, item)) {
          checkDisabled = true;
        }
      })
    })

    return checkDisabled
  }
export const detectMob=()=> {
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
    return isMobile;
  }
  export const isCurrentTimeWithinDateRange = (startDate, endDate) => {
 const startDateTime = new Date(startDate).setHours(0, 0, 0, 0);
    const endDateTime = new Date(endDate || 86400000000000).setHours(23, 59, 59, 999);
    const currentDateTime = new Date().getTime();
    return currentDateTime >= startDateTime && currentDateTime <= endDateTime;
};


export const splitMultiBrandCarts = (carts = []) => {
    const result = [];

    carts.forEach(cart => {
      const isMultiBrand = cart?.brand_user?.is_multi_brand;

      // If NOT multi-brand → keep cart as-is
      if (!isMultiBrand) {
        result.push(cart);
        return;
      }

      // Group cart_items by vendor id
      const vendorMap = {};

      cart.cart_items.forEach(item => {
        const vendorId = item?.products?.shopify_vendor?.id;

        if (!vendorMap[vendorId]) {
          vendorMap[vendorId] = [];
        }
        vendorMap[vendorId].push(item);
      });

      const vendorIds = Object.keys(vendorMap);

      // If only ONE vendor → keep cart as-is
      if (vendorIds.length === 1) {
        result.push(cart);
        return;
      }

      // Multiple vendors → split into multiple carts
      vendorIds.forEach(vendorId => {
        result.push({
          ...cart,
          cart_items: vendorMap[vendorId],
        });
      });
    });

    return result;
  }
  export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
export const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const allDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
};
const phoneDigits = (value) => allDigits(value).slice(0, 10);
const formatPhone = (value) => {
  const d = phoneDigits(value);
  if (d.length > 6) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length > 3) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return d.length ? `(${d}` : '';
};
/* A complete US number is formatted; anything else is shown as typed — formatting a partial number invents a shape for it. */
export const phoneDisplay = (value) => {
  const s = String(value || '').trim();
  return allDigits(s).length === 10 && /^[\d\s().+-]+$/.test(s) ? formatPhone(s) : s;
};
